<div class="app">
  <router-outlet></router-outlet>
  <app-notification-wrapper
    class="notification-wrapper"
  ></app-notification-wrapper>
  <app-login-to-waves [disableControls]="true"></app-login-to-waves>
</div>
